import { combineReducers } from "redux";
import { reducer as reduxForm } from "redux-form";
import authReducer from "./authReducer";
import brandsReducer from "./brandsReducer";
import colorsReducer from "./colorsReducer";
import categoriesReducer from "./categoriesReducer";
import displaysReducer from "./displaysReducer";
import groupsReducer from "./groupsReducer";
import locationUsersReducer from "./locationUsersReducer";
import menuItemsReducer from "./menuItemsReducer";
import menuItemsMediaReducer from "./menuItemsMediaReducer";
import mediasReducer from "./mediasReducer";
import sessionReducer from "./sessionReducer";
import sortOptionsReducer from "./sortOptionsReducer";
import strainTypesReducer from "./strainTypesReducer";
import subscriptionReducer from "./subscriptionReducer";
import terpeneProfilesReducer from "./terpeneProfilesReducer";
import themesReducer from "./themesReducer";
import userLocationsReducer from "./userLocationsReducer";
import zohoCustomersReducer from "./zohoCustomersReducer";

export default combineReducers({
  auth: authReducer,
  form: reduxForm,
  brands: brandsReducer,
  colors: colorsReducer,
  categories: categoriesReducer,
  displays: displaysReducer,
  groups: groupsReducer,
  locationUsers: locationUsersReducer,
  medias: mediasReducer,
  menuItems: menuItemsReducer,
  menuItemsMedia: menuItemsMediaReducer,
  session: sessionReducer,
  sortOptions: sortOptionsReducer,
  strainTypes: strainTypesReducer,
  subscription: subscriptionReducer,
  terpeneProfiles: terpeneProfilesReducer,
  themes: themesReducer,
  userLocations: userLocationsReducer,
  zohoCustomers: zohoCustomersReducer
});

/*
import { combineReducers } from "redux";
import { reducer as reduxForm } from "redux-form";
import authReducer from "./authReducer";
import menusReducer from "./menusReducer";
import menuReducer from "./menuReducer";
import groupsReducer from "./groupsReducer";
import listsReducer from "./listsReducer";
import cardsReducer from "./cardsReducer";
import boardsReducer from "./boardsReducer";
import boardOrderReducer from "./boardOrderReducer";
import activeBoardReducer from "./activeBoardReducer";
import productReducer from "./productReducer";

export default combineReducers({
  auth: authReducer,
  form: reduxForm,
  menus: menusReducer,
  menu: menuReducer,
  groups: groupsReducer,
  lists: listsReducer,
  cards: cardsReducer,
  boards: boardsReducer,
  boardOrder: boardOrderReducer,
  activeBoard: activeBoardReducer,
  product: productReducer
});
*/
